import {
	IconCreditCard,
	IconDeviceDesktop,
	IconMessages,
	IconReceipt2,
	IconUsers,
} from "@tabler/icons-react";
import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/")({
	component: RouteComponent,
});

const links = [
	{
		to: "/admin/users",
		label: "Users",
		description: "用户管理",
		icon: IconUsers,
	},
	{
		to: "/admin/threads",
		label: "Threads",
		description: "对话管理",
		icon: IconMessages,
	},
	{
		to: "/admin/subscriptions",
		label: "Subscriptions",
		description: "订阅管理",
		icon: IconCreditCard,
	},
	{
		to: "/admin/credit",
		label: "Credit",
		description: "点数管理",
		icon: IconReceipt2,
	},
	{
		to: "/admin/sandbox",
		label: "Sandbox",
		description: "沙盒环境",
		icon: IconDeviceDesktop,
	},
] as const;

function RouteComponent() {
	return (
		<div className="p-8">
			<h1 className="mb-1 text-2xl font-bold">Admin</h1>
			<p className="mb-8 text-sm text-muted-foreground">管理后台</p>
			<div className="grid grid-cols-2 gap-4 lg:grid-cols-5">
				{links.map((link) => (
					<Link
						key={link.to}
						to={link.to}
						className="group flex flex-col gap-3 rounded-xl border bg-card p-5 transition-colors hover:border-foreground/20 hover:bg-accent"
					>
						<link.icon className="size-6 text-muted-foreground transition-colors group-hover:text-foreground" />
						<div>
							<div className="font-medium">{link.label}</div>
							<div className="text-sm text-muted-foreground">{link.description}</div>
						</div>
					</Link>
				))}
			</div>
		</div>
	);
}
